export const environment = {
    WEB_API_URL: 'https://api.sueldos.uy/',
    SUELDOS_ENV: 'production',
    AIRBRAKE_PROJECT_ID: 345427,
    AIRBRAKE_PROJECT_KEY: '87e112df84e9a3a07e269c3bad53c414',
    production: true,
};
